export const PRODUCTS = [
    {
        id: 'ebook-lash-01',
        title: 'Apostila Lash Designer Iniciante',
        type: 'ebook',
        price: 97.00,
        status: 'active',
        description: 'Guia completo para iniciar sua carreira com técnicas fundamentais e dicas de materiais.',
        image: 'https://placehold.co/600x400/FF7EAF/ffffff?text=Apostila+Lash' // Placeholder image matching brand
    },
    {
        id: 'curso-lash-01',
        title: 'Curso Completo Lash Master',
        type: 'course',
        price: 297.00,
        status: 'coming_soon',
        description: 'Domine todas as técnicas avançadas, do clássico ao volume russo, com certificação.',
        image: 'https://placehold.co/600x400/1a1a1a/FF7EAF?text=Curso+Master' // Placeholder image matching brand
    }
];
